import React, { useState, useEffect, useRef } from "react";
import t1 from "../../assets/images/t-1.png";
import t2 from "../../assets/images/t-2.png";
import t3 from "../../assets/images/t-3.png";
import t4 from "../../assets/images/t-4.png";
import t5 from "../../assets/images/t-5.png";
import t6 from "../../assets/images/t-6.png";
import t7 from "../../assets/images/t-7.png";
import t8 from "../../assets/images/t-8.png";
import t9 from "../../assets/images/t-9.png";

const imagePaths = [t1, t2, t3, t4, t5, t6, t7, t8, t9];

const CompanProfile = () => {
  const [loadedImages, setLoadedImages] = useState([]);
  const [activeSection, setActiveSection] = useState(null);
  const sectionRefs = useRef([]);

  useEffect(() => {
    const loadImages = async () => {
      const imagePromises = imagePaths.map((src) => {
        return new Promise((resolve) => {
          const img = new Image();
          img.src = src;
          img.onload = () => resolve(src);
          img.onerror = () =>
            resolve(
              "https://via.placeholder.com/1100x600?text=Image+Not+Found"
            );
        });
      });

      const loaded = await Promise.all(imagePromises);
      setLoadedImages(loaded);
    };

    loadImages();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight / 2;
      sectionRefs.current.forEach((ref, index) => {
        if (
          ref &&
          ref.offsetTop <= scrollPosition &&
          ref.offsetTop + ref.offsetHeight > scrollPosition
        ) {
          setActiveSection(index);
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (index) => {
    const ref = sectionRefs.current[index];
    if (ref) {
      ref.scrollIntoView({ behavior: "smooth" });
    }
  };

  const navItemStyle = {
    color: "#1B2F57",
    textDecoration: "none",
    cursor: "pointer",
    padding: "4px 0",
    display: "block",
  };

  const activeNavItemStyle = {
    ...navItemStyle,
    fontWeight: "bold",
    color: "#fff",
    backgroundColor: "#1B2F57",
    borderRadius: "4px",
    padding: "6px 10px",
  };

  return (
    <>
      {/* Image Stack Section */}
      <div
        className="image-stack-section"
        style={{
          position: "relative",
          height: `${loadedImages.length * 100}vh`,
        }}
      >
        {loadedImages.map((image, index) => {
          const isLast = index === loadedImages.length - 1;
          const offset = index <= activeSection ? 0 : 100;
          const scale = index === activeSection ? 1 : 0.95;
          const opacity = Math.abs(index - activeSection) > 1 ? 0.3 : 1;

          return (
            <div
              key={index}
              ref={(el) => (sectionRefs.current[index] = el)}
              style={{
                position: isLast ? "relative" : "sticky",
                top: isLast ? "unset" : "20px",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                transition: "all 0.5s ease",
                transform: `translateY(${offset}px) scale(${scale})`,
                // opacity: opacity,
                zIndex: loadedImages.length - index,
                padding: "0 16px",
                marginBottom: isLast ? "200px" : "0",
              }}
            >
              <img
                src={image}
                alt={`Capital Intel ${index + 1}`}
                style={{
                  width: "100%",
                  maxWidth: "1100px",
                  borderRadius: "12px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
                }}
                onError={(e) => {
                  e.target.src =
                    "https://via.placeholder.com/1100x600?text=Image+Not+Found";
                }}
              />
            </div>
          );
        })}
      </div>

      {/* Sidebar + Content Section */}
      <div
        style={{
          display: "flex",
          maxWidth: "1100px",
          margin: "0 auto",
          padding: "40px 16px",
          gap: "24px",
        }}
      >
        {/* Sidebar */}
        <div style={{ width: "30%" }}>
          <div
            style={
              {
                // backgroundColor: '#f5f5f5',
                // padding: '20px',
                // borderRadius: '8px',
                // boxShadow: '0 4px 10px rgba(0,0,0,0.1)'
              }
            }
          >
            <h2 style={{ fontSize: "18px", marginBottom: "36px" }}></h2>
            <ul style={{ listStyle: "none", padding: 0, lineHeight: "1.8" }}>
              {/* {loadedImages.map((_, index) => (
                <li key={index}>
                  <span
                    onClick={() => scrollToSection(index)}
                    style={
                      activeSection === index
                        ? activeNavItemStyle
                        : navItemStyle
                    }
                  >
                    Section {index + 1}
                  </span>
                </li>
              ))} */}

              {/* <li><a href="#" style={{ color: '#1B2F57', textDecoration: 'none' }}>Overview</a></li>
              <li><a href="#" style={{ color: '#1B2F57', textDecoration: 'none' }}>Analytics</a></li>
              <li><a href="#" style={{ color: '#1B2F57', textDecoration: 'none' }}>Strategy</a></li>
              <li><a href="#" style={{ color: '#1B2F57', textDecoration: 'none' }}></a></li> */}
            </ul>
          </div>
        </div>
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
    </>
  );
};

export default CompanProfile;
